(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class HeroSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
      this.selectors = {
        slider: '[data-slider]',
        thumbs: '[data-thumbs]',
        slide: '.swiper-slide',
      };
      this.elements = {
        slider: this.querySelector(this.selectors.slider),
        thumbs: this.querySelector(this.selectors.thumbs),
      }
    }

    connectedCallback() {
      this.initSlider();

      window.addEventListener('resize', this.activateThumbs.bind(this))
    }

    initSlider() {
      if (!this.elements.slider || !this.elements.thumbs)
        return;

      const loop = this.elements.slider.querySelectorAll(this.selectors.slide).length > 1

      this.options = {
        slider: {
          navigation: {
            prevEl: this.querySelector('.swiper-arrow--prev'),
            nextEl: this.querySelector('.swiper-arrow--next'),
          },
          speed: 1000,
          loop: loop,
          slidesPerView: 1,
          spaceBetween: 0,
        },
        thumbs: {
          slidesPerView: 'auto',
          watchSlidesProgress: true,
          watchOverflow: true,
          autoScrollOffset: 0,
          slideToClickedSlide: true,
          centeredSlides: true,
          centeredSlidesBounds: true,
          spaceBetween: 8,
          centerInsufficientSlides: true,
          enabled: false,
          breakpoints: {
            989: {
              enabled: true
            }
          }
        }
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.slider.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      this.activateThumbs();
      this.slider = new Swiper(
        this.elements.slider,
        this.options.slider,
      );
    }

    activateThumbs() {
      if (window.matchMedia('(min-width: 989px)').matches && !this.thumbs) {
        this.thumbs = new Swiper(
          this.elements.thumbs,
          this.options.thumbs,
        );

        if (this.slider) {
          this.slider.thumbs.swiper = this.thumbs;
          this.slider.thumbs.init();
          this.slider.thumbs.update();
        }

        this.options.slider.thumbs = {
          swiper: this.thumbs,
        };
      }
    }
  }

  customElements.define('hero-slider', HeroSlider);
})();
